import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { Drawer, Form, Input, Select as SelectAnt } from 'antd';
import { postApi } from '../../services/api';
import { searchEmployeeApi } from '../../services/employee';
import { useDispatch } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';
import _, { debounce } from 'lodash';

const bugetOptions = [
	{
		label: 'Low Computing – ₹1,00,000',
		value: 'Low Computing – ₹1,00,000',
	},
	{
		label: 'Medium Computing – ₹1,50,000',
		value: 'Medium Computing – ₹1,50,000',
	},
	{
		label: 'High Computing – ₹2,00,000',
		value: 'High Computing – ₹2,00,000',
	},
];

const CreateNewOnboardingRequest = ({ companyData }) => {
	const [open, setOpen] = useState(false);
	const [form] = Form.useForm();
	const [employeeList, setEmployeeList] = useState([]);
	const [adminList, setAdminList] = useState([]);
	const [filteText, setFilterText] = useState(null);
	const [adminSearchText, setAdminSearchText] = useState(null);
	const [empId, setEmpId] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		const getEmployeeList = async function () {
			const resp = postApi({ filteText }, '/users/get-employee?provideAssetCount=no');
			if (resp.type === 'success') {
			}
		};
		getEmployeeList();
	}, [filteText]);

	const showDrawer = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	const onSave = async (values) => {
		console.log(values, 'values');
		const resp = await postApi(values, '/assetze/emp-pre-onboarding');
		if (resp.type === 'success') {
			form.resetFields();
			onClose();
			dispatch(
				showSnack('ASSET_NOT_FOUND', {
					label: 'Successfully created pre on boarding request for employee',
					timeout: 7000,
				})
			);
		} else {
			dispatch(
				showSnack('ASSET_NOT_FOUND', {
					label: resp.error,
					timeout: 7000,
				})
			);
		}
	};

	const promiseOptions = async (inputValue) => {
		const emplList = await searchEmployeeApi(inputValue);
		const resp = emplList.map((el) => ({
			value: el.empId,
			label: `${el.name}-${el.department ? el.department : ''}`,
		}));
		setEmployeeList(resp);
		return resp;
	};

	const promiseAdminOptions = async (inputValue) => {
		const resp = await postApi({ filterText: inputValue }, '/users/get-admins');
		if (resp.type === 'success') {
			setAdminList(
				resp.admins.map((el) => ({
					label: `${el.firstName}-${el.email}`,
					value: el._id,
				}))
			);
		}
	};

	const handleSearch = debounce(async function (value) {
		promiseOptions(value);
	}, 500);
	const handleITAdminSearch = debounce(async function (value) {
		promiseAdminOptions(value);
	}, 500);

	if (!companyData) {
		return null;
	}

	if (!companyData.roles) {
		return null;
	}
	if (companyData.roles.indexOf('candidate-onboard') === -1) {
		return null;
	}
	return (
		<>
			<Button onClick={showDrawer} type="primary">
				Candidate Onboard
			</Button>
			<Drawer title="Employee Pre Onboarding" onClose={onClose} open={open}>
				<Form form={form} onFinish={onSave} layout="vertical" hideRequiredMark>
					<Form.Item rules={[{ required: true }]} name="name" label="Employee Name">
						<Input placeholder={'Employee Name'} />
					</Form.Item>
					<Form.Item rules={[{ required: true, type: 'email' }]} name="email" label="Employee Email">
						<Input placeholder={'Employee Email'} />
					</Form.Item>
					<Form.Item rules={[{ required: true }]} name="authHrIds" label="Authorized HR Email(Employee)">
						<SelectAnt
							filterOption={false}
							showSearch
							mode="multiple"
							allowClear
							style={{
								width: '100%',
							}}
							placeholder="Authorized HR Email"
							onSearch={handleSearch}
							options={employeeList}
							className="filter-select"
							onChange={(value) => {
								setEmpId(value);
							}}
						/>
					</Form.Item>
					<Form.Item name="adminIT" label="Select IT Admin">
						<SelectAnt
							filterOption={false}
							showSearch
							mode="multiple"
							allowClear
							style={{
								width: '100%',
							}}
							placeholder="Select IT Admin"
							onSearch={handleITAdminSearch}
							options={adminList}
							className="filter-select"
							onChange={(value) => {
								setAdminSearchText(value);
							}}
						/>
					</Form.Item>

					<Form.Item rules={[{ required: true }]} name="budgetPreferred" label="Select Budget">
						<SelectAnt
							filterOption={false}
							style={{
								width: '100%',
							}}
							placeholder="Select Budget"
							options={bugetOptions}
							className="filter-select"
							onChange={(value) => {
								setEmpId(value);
							}}
						/>
					</Form.Item>

					<div style={{ marginBottom: '20px' }}>
						*Mail will be sent to respective employee for device selection
					</div>
					<Form.Item label={null}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Drawer>
		</>
	);
};

export default CreateNewOnboardingRequest;
